// @flow
import styled from "styled-components";

export const Outer = styled.div`
    font-size: 0;
`;

export const PhotoOuter = styled.div`
    display: inline-block;
    background-color: #eee;
    position: relative;
`;

export const PhotoHolder = styled.div`
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
`;

export const Quarter = styled(PhotoOuter)`
    width: 25%;
    padding-top: 25%;
`;

export const Third = styled(PhotoOuter)`
    width: 33.333%;
    padding-top: 33.333%;
`;

export const Half = styled(PhotoOuter)`
    width: 50%;
    padding-top: 50%;
`;



// WEBPACK FOOTER //
// ./src/blog-card/photos/styled.js